// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.document-btn {\n  letter-spacing: 0.1px !important;\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 20px;\n}\n.document-table th span {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 16px;\n  text-transform: uppercase;\n  color: #797979;\n}\n.document-table td,\n.document-table th {\n  padding: 0px 8px !important;\n}\n", ""]);
// Exports
module.exports = exports;
